import PropTypes from 'prop-types';
import React from 'react';
import SpotIMContainer from '../../common/spot_im_container';
import { envSpecificSpotID } from '../../../utils/env';
import withViewportScrollTracking from '../../hocs/withViewportScrollTracking';

export const ProductDetailsComments = ({
  product: { comments_id },
  edition_data: { config: { spotim_id } },
  analytics: { url_full }
}, { location }) => {
  const spotID = envSpecificSpotID(location.hostname, spotim_id);

  return (
    <SpotIMContainer
      spotID={spotID}
      id="product-detail-comments"
      renderID={comments_id}
      className="spot-im-products-reviews-container"
      scriptURL={`https://launcher.spot.im/spot/${spotID}`}
      scriptOptions={{
        async: true,
        attrs: {
          'data-spotim-module': 'spotim-launcher',
          'data-post-url': url_full,
          'data-post-id': comments_id,
          'data-messages-count': 3,
          'data-sort-by': 'best',
          'data-conversation-skin': 'light',
          'data-social-reviews': 'true'
        }
      }}
    />
  );
};

ProductDetailsComments.propTypes = {
  product: PropTypes.object.isRequired,
  edition_data: PropTypes.shape({
    config: PropTypes.shape({
      spotim_id: PropTypes.string
    }).isRequired
  }).isRequired,
  analytics: PropTypes.shape({
    url_full: PropTypes.string.isRequired
  }).isRequired
};

ProductDetailsComments.contextTypes = {
  location: PropTypes.object
};

const decorator = withViewportScrollTracking({
  eventParams: () => ['Scroll Depth', 'Scroll', 'Comments']
});

export default decorator(ProductDetailsComments);
